import React, { useContext, useEffect } from "react";

import AppContext from "../../AppContext";
import { DisqualifyingReason, DisqualifyingReasonResponse } from "../../dtos/DisqualifyingReason";
import { Step } from "../../types/Step";
import { ViewConnector } from "../../types/ViewConnector";
import { useObx } from "../../utils/UseObx";
import { Flow } from "../../V2/Flows/Types/IFlow";

interface DisqualifyingReasonsProps {
  viewConnector: ViewConnector;
}

const getFlowNeedsDisqualifyingReasons = (flow: Flow): boolean =>
  flow.ContainsStep(Step.qualify) || flow.ContainsStep(Step.medicalGeneral);

/** Obtains the allowed disqualifying reasons from the api. */
const DisqualifyingReasons: React.FC<DisqualifyingReasonsProps> = ({ viewConnector }) => {
  const { disqualifyingReasonsCState, flowCState, contactId, setDisqualifyingReasonsCState } = useContext(AppContext);
  const flowNeedsDisqualifyingReasons = getFlowNeedsDisqualifyingReasons(flowCState);
  const { res, err } = useObx<DisqualifyingReasonResponse[]>("Disqualifying Reasons", {
    url: `Legacy/V0/Contacts/${contactId}/DisqualifyingReasons`,
    noRequest: Boolean(disqualifyingReasonsCState) || !flowNeedsDisqualifyingReasons
  });
  useEffect(() => {
    if (!flowNeedsDisqualifyingReasons) setDisqualifyingReasonsCState([]);
  }, []);
  useEffect(
    () =>
      res &&
      setDisqualifyingReasonsCState(
        res.payload.map(({ leadResultTypeId, ...rest }): DisqualifyingReason => ({
          ...rest,
          contactResultTypeId: leadResultTypeId
        }))
      ),
    [res]
  );
  useEffect(() => err && viewConnector.goToSomethingWentWrongView(), [err]);

  return <React.Fragment />;
};

export default DisqualifyingReasons;
